import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import HRPortal from '../components/HRPortal';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const HRPortalPage = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API}/api/hr-portal/check-access`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.has_access) {
          setHasAccess(true);
        } else {
          toast.error('HR Department access required');
          navigate('/dashboard');
        }
      } catch (error) {
        toast.error('Access denied');
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50" data-testid="hr-portal-page">
      <Header user={user} setUser={setUser} />
      <Navigation user={user} />
      
      <main className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <HRPortal user={user} />
      </main>
    </div>
  );
};

export default HRPortalPage;
